'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'map-marker-slash';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f60c';
var svgPathData = 'M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM320 48c79.4 0 144 64.6 144 144 0 25.07-2.93 41.62-18.88 70.43l38.23 29.89C505.9 253.46 512 228.95 512 192 512 86.4 425.6 0 320 0c-53.42 0-101.88 22.16-136.77 57.69l38.22 29.88C247.25 63.21 281.8 48 320 48zm39.41 342.09c-11.9 16.87-25 35.44-39.41 55.99-14.41-20.56-27.51-39.12-39.41-55.99-58.27-82.6-84.42-120.33-95.93-148.51l-56.53-44.2c1.27 72.49 29.05 98.96 172.67 305.02 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6c24.46-35.1 45.29-64.59 63.48-90.38l-37.87-29.6c-1.84 2.61-3.5 4.97-5.4 7.67z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faMapMarkerSlash = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;